import { useState } from "react";
import { PlayCircle } from "lucide-react";

// Click-to-play YouTube facade — nothing loads/plays until the user clicks.
export default function YouTubeEmbed({ id, title }) {
  const [play, setPlay] = useState(false);
  return (
    <div className="relative rounded-[2rem] overflow-hidden border-4 border-sq-ink shadow-[0_10px_0_#111827] bg-black aspect-video">
      {play ? (
        <iframe
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          data-testid="youtube-iframe"
          className="w-full h-full"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button onClick={() => setPlay(true)} data-testid="youtube-play" aria-label={`Play ${title}`} className="group absolute inset-0 w-full h-full">
          <img src={`https://img.youtube.com/vi/${id}/maxresdefault.jpg`} alt={title} loading="lazy" className="w-full h-full object-cover" />
          <span className="absolute inset-0 grid place-items-center bg-black/25 group-hover:bg-black/10 transition-colors">
            <span className="grid place-items-center w-20 h-20 rounded-full bg-sq-red text-white shadow-2xl group-hover:scale-110 transition-transform">
              <PlayCircle size={42} />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
